import { useTranslation } from 'react-i18next';

import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';
import { IParticipant } from 'src/interfaces/Participant';
import TransferForm from 'src/pages/Dashboard/Participants/forms/TransferForm';

interface Props {
  open: boolean;
  handleClose: () => void;
  handleSave: (email: string, dateOfBirth: Date | null) => void;
  selectedParticipant?: IParticipant;
}

const TransferModal = ({ open, handleClose, handleSave, selectedParticipant }: Props) => {
  const { t } = useTranslation();

  return (
    <EditorDialogShell
      id="transfer"
      open={open}
      onClose={handleClose}
      title={t('participants.transferParticipantModalTitle')}
      maxWidth="sm"
    >
      <TransferForm
        handleSave={handleSave}
        handleClose={handleClose}
        selectedParticipant={selectedParticipant}
      />
    </EditorDialogShell>
  );
};

export default TransferModal;
